
import Vue from 'vue';

export {auth};

const auth = Vue.directive('auth', {
    inserted:(el, binding, node) => {
        let user = JSON.parse(sessionStorage.getItem('userObj'));
        if(user && user.superAdmin == 1){//超级管理员拥有所有权限
            return;
        }
        let key = "sh_user_btns_check_" + user.id;
        let btn = sessionStorage.getItem(key);
        if(!btn || btn.indexOf(binding.value) < 0){
            if(el.parentNode && el.parentNode.removeChild){
                el.parentNode.removeChild(el);
            }else{
                el.style.display = 'none';
            }
        }
    },
    update:(el, binding, node) => {
        let user = JSON.parse(sessionStorage.getItem('userObj'));
        if(user && user.superAdmin == 1){//超级管理员拥有所有权限
            return;
        }
        let key = "sh_user_btns_check_" + user.id;
        let btn = sessionStorage.getItem(key);
        if(!btn || btn.indexOf(binding.value) < 0){
            if(el.parentNode && el.parentNode.removeChild){
                el.parentNode.removeChild(el);
            }else{
                el.style.display = 'none';
            }
        }
    },
});




// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/auth/auth.js